import $ from 'jquery';
import {initContestCustomFields} from './custom-fields';
import {initWysiwyg} from './wysiwyg';
import initDeleteQuizStep from './delete-quiz-steps';
import {showFormResponse, clearStatusMessages} from "../common/json-response";

let fieldsData = {};

function getFields() {
  const fieldsData = {};
  const creatingType = document.querySelector('[name="quiz_params[creating_type]"]:checked');
  fieldsData['quiz_creating_type_id'] = creatingType?.value
  const fields = document.querySelectorAll('.send-quiz-step:not([disabled])');

  fields?.forEach(input => {
      fieldsData[input.name] = input.value;
  });

  return fieldsData;
}

export default function() {
  const block = document.querySelector('#quiz_steps_items');
  const addBtn = document.querySelector('.btn[name="addQuizStep"]');
  addBtn?.addEventListener('click', function (e) {
    e.preventDefault();
    $.ajax({
      type: "GET",
      url: addBtn.getAttribute('data-add-url'),
      dataType: 'html',
      success: function (data) {
        block.insertAdjacentHTML('beforeEnd', data);
        initContestCustomFields();
        initWysiwyg();
        initDeleteQuizStep();
      }
    });
  });

  const saveBtn = document.querySelector('.btn[name="saveQuizStepsSettings"]');

  saveBtn?.addEventListener('click', function (e) {
    e.preventDefault();

    clearStatusMessages();
    fieldsData = getFields();
    const url = this.getAttribute('data-save-url');

    $.ajax({
      type: "POST",
      url: url,
      dataType: 'json',
      data: fieldsData,
      success: function (data) {
        if (data.redirectTo?.length) {
          window.location.href = data.redirectTo;
        }

        showFormResponse(data);

        if (data.status === 'success' && data.steps) {
          // block.insertAdjacentHTML('beforeEnd', data);
          // initContestCustomFields();
        }
      },
      error: function (data) {
        showFormResponse(data);
      },
    });
  });
}